import React, { Component } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import bannerImage from "../../Images/Banner/honarable-banner.webp";
import viceChancellor from "../../Images/Hon'ble Persons/Dr. Vinay M. Agrawal-6.webp"

const AboutUs = () => {
    return (
        <>
            <title>Discover ISBM University's Chancellor: Visionary Leadership</title>
            <meta
                name="description"
                content="Discover the the leadership at ISBM University through the eyes of the Honorable Chancellor. Explore his visionary role in shaping the educational landscape."
            />
           
            <meta
                name="SearchEngines"
                content="Google, Bing, Overture, Yahoo, AOL, Infoseek, LookSmart, Excite, Hotbot, Lycos, CNET,
        DogPile, Ask Jeeves, Teoma, Snap, WebCrawler, AltaVista, GigaBlast, isoHunt, Kayak, MetaCrawler"
            />
            <meta name="Robots" content="INDEX, FOLLOW" />
            <meta name="Author" content="ISBM University, isbmuniversity.edu.in/" />
            <meta name="Robots" content="INDEX,ALL" />
            <meta name="YahooSeeker" content="INDEX, FOLLOW" />
            <meta name="msnbot" content="INDEX, FOLLOW" />
            <meta name="googlebot" content="Default, follow" />
            <meta name="owner" content="isbmuniversity.edu.in/" />
            <meta name="language" content="English" />
            <meta name="revisit-after" content="2 days" />
            <meta
                property="og:title"
                content="Discover ISBM University's Chancellor: Visionary Leadership "
            />
            <meta
                property="og:description"
                content="Discover the the leadership at ISBM University through the eyes of the Honorable Chancellor. Explore his visionary role in shaping the educational landscape."
            />
            <meta
                property="og:url"
                content="https://isbmuniversity.edu.in/honorable-chancellor/"
            />
            <meta
                property="og:image"
                content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
            />
            <meta property="og:image:alt" content="ISBM University" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="ISBM University" />
            <meta
                name="twitter:title"
                content="Discover ISBM University's Chancellor: Visionary Leadership"
            />
            <meta
                name="twitter:description"
                content="Discover the the leadership at ISBM University through the eyes of the Honorable Chancellor. Explore his visionary role in shaping the educational landscape."
            />
            <meta
                name="twitter:image:src"
                content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
            />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:site" content="@ISBMUniversity" />
            <meta name="twitter:creator" content="@ISBMUniversity" />
            <meta name="twitter:domain" content="https://isbmuniversity.edu.in/" />
            <meta property="twitter:account_id" content="758619542734053376" />
            <meta name="keywords" content="Leadership Vision , Future of Education , ISBM University" />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>From The Chancellor's Desk</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    Hon'ble Chancellor
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="vc-section ptb-50">
                <div className="container-xxl">
                    <div className="vc-container">
                        <div className="vc-image-container">
                            <div className="vc-image-wrapper shadow-sm">
                                <img src={viceChancellor} alt="Prof. (Dr.) Anand Mahalwar" className="vc-image" />
                                <div className="vc-image-overlay"></div>
                            </div>
                            <div className="vc-title-box">
                                <span className="vc-designation">Hon'ble Chancellor</span>
                                <h2 className="vc-name">Dr. Vinay M. Agrawal</h2>
                            </div>
                        </div>

                        <div className="vc-content">
                            <div className="vc-message">
                                <p>
                                    <span className="fw-bold">Education is an intervention in the modern society where, harmonious development can be achieved by enlightenment of an individual's heart, mind and soul.</span> I am of the opinion that education can transform the attitude, thought process and lifestyle of the people leading to the development of the society Education makes people flexible in thinking rationally and making appropriate decisions. I have always worked towards empowering the mass. Education serves as the tool & technique of empowerment with skilled and socially relevant citizens.</p>
                                <div className="vc-highlight-box fw-semibold">
                                    <p>
                                        ISBM University stands for humanism, rationality, idea exploration and innovation. The approach of our curriculum focuses on experiential learning ensuring better content delivery and provisions for co-curricular, extra-curricular activities as integral components of the learning process.
                                    </p>
                                </div>
                                <blockquote className="vc-quote">
                                    At ISBM University we seek self-motivated individuals who believe in making their own methods of learning by availing the opportunities and willing to contribute their best for social welfare.
                                </blockquote>

                                <p className="p-0">
                                    ISBM University is proud of its state of the art infrastructure, serene campus with aesthetically built facilities. Student's friendly policies create a satisfying academic ambience in the campus. I extend my best wishes to all the aspirants in the campus and assure them that under the mentorship of experienced faculties of ISBM University they will be able to extract competitive advantage towards creating a harmonious, peaceful and rewarding future. Participation in a wide range of academics and other activities will provide them an opportunity to acquire leadership, skills, professional and personal traits.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default AboutUs;
